import {SECRET_KEY} from "../index";
import forge from 'node-forge';

const AES_GCM = 'AES-GCM'
const TAG_LENGTH_BYTES = 16;

const decrypt = async (encryptedData: string, iv: string): Promise<string> => {
  try {
    const decodedKey = forge.util.decode64(SECRET_KEY);
    const ivBytes = forge.util.decode64(iv);
    const encryptedBytes = forge.util.decode64(encryptedData);

    const ciphertextBytes = encryptedBytes.slice(0, encryptedBytes.length - TAG_LENGTH_BYTES);
    const tagBytes = encryptedBytes.slice(encryptedBytes.length - TAG_LENGTH_BYTES);

    const decipher = forge.cipher.createDecipher(AES_GCM, decodedKey);

    decipher.start({ iv: ivBytes, tag: tagBytes });
    decipher.update(forge.util.createBuffer(ciphertextBytes));

    const result = decipher.finish();

    if (!result) {
      throw new Error("El tag de autenticación no coincide. Los datos podrían estar corruptos o alterados.");
    }

    const decryptedData = decipher.output.toString('utf-8');

    return decryptedData;
  } catch (error) {
    throw new Error(`Error en la desencriptación: ${error.message}`);
  }
};

export const decryptSymmetric = async (encryptedData: string, iv: string) => {
  return decrypt(encryptedData, iv);
};